export function debugit(...args) {
  // Check if the current URL has the `debugAcs` parameter
  const urlParams = new URLSearchParams(window.location.search);
  
  if (urlParams.has('debugit')) {
    // If `debugAcs` is present, log all arguments passed to `debugit`
    console.log(...args);
  }
}
window.debugit = debugit;